import { makeImmutable } from "../../core";
export class ModifierItemPackagingFeeRequirement {
    constructor(params) {
        this.modifierTypeId = params.modifierTypeId;
        this.modifierItemTypeIds = params.modifierItemTypeIds;
        makeImmutable(this);
    }
    testProduct(_) {
        return false;
    }
    testModifier(modifierInstance, modifierItemTypeId) {
        if (!this.modifierTypeId.eq(modifierInstance.modifierType.id)) {
            return false;
        }
        return this.modifierItemTypeIds.includes(modifierItemTypeId);
    }
}
